export default __webpack_public_path__ + "static/media/res-popup-close.f58b735f.svg";